// Client-side telemetry (No-Op replacement)
import { logger } from './logger'

// Client-safe Telemetry initialization
export async function initializeClientTelemetry() {
  if (typeof window === 'undefined') {
    return
  }

  if (process.env.NODE_ENV === 'development') {
    logger.debug('[Client Telemetry] Initialized (No-Op)')
  }

  // Mock the window object for legacy support if needed
  ;(window as any).__payK12Telemetry = {
    provider: null,
    tracer: {
      startSpan: () => ({
        setAttributes: () => {},
        setStatus: () => {},
        recordException: () => {},
        end: () => {},
      }),
    },
  }
}

/**
 * Get client-side tracer for manual instrumentation
 */
export function getClientTracer() {
  if (typeof window === 'undefined') {
    return null
  }
  return (window as any).__payK12Telemetry?.tracer || null
}

/**
 * Record custom client-side event
 */
export function recordClientEvent(eventName: string, attributes?: Record<string, any>) {
  if (process.env.NODE_ENV === 'development') {
    logger.debug(`[Client Telemetry] Record event: ${eventName}`, attributes)
  }
}
